export default __webpack_public_path__ + "static/media/6.8beedc4d.png";